import { css } from '@emotion/react';
import t from 'react-translate';
import NvIcon from 'shared/components/nv-icon';
import prodPathReplace from 'shared/prod-path-rewrite';
import { getProgramDatesText } from 'athena/components/program-header/program-dates';
import { MentoringProgram } from 'redux/schemas/models/mentoring-programs';
import { threeQuartersSpacing } from 'styles/global_defaults/scaffolding';


const styles = css`
  background: url('${prodPathReplace('images/program-flyer-bg.png')}');
  background-size: cover;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;

  .badge {
    border-radius: 18px;
    padding: 7.5px ${threeQuartersSpacing}px;
  }
`;

type FlyerHeaderProps = {
  program?: Partial<MentoringProgram>;
  isMentee?: boolean;
};

const FlyerHeader = ({ program, isMentee }: FlyerHeaderProps) => {
  const {
    programAlias,
    name,
    description,
    releasedDate,
    endDate,
  } = program ?? {};

  const roleAlias = (isMentee ? programAlias?.mentee : programAlias?.mentor)?.downcasedPluralized ?? '';
  const badgeColorClassNames = isMentee ? 'color-white bg-color-success' : 'color-black bg-color-yellow';

  return (
    <div className='d-flex flex-column align-items-center p-5' css={styles}>
      <div className={`badge text-small bold ${badgeColorClassNames}`}>{t.MENTORING_PROGRAMS.FLYER.NOW_ACCEPTING(roleAlias)}</div>
      <div className='heading-1 mt-3'>{name}</div>
      <div className='text-large-body color-gray-1 mt-3'>{description}</div>
      {releasedDate && (
        <div className='d-flex align-items-center mt-3'>
          <NvIcon icon='calendar' size='xs-smallest' className='mr-1 color-gray-3' />
          <span className='color-gray-1'>{getProgramDatesText(releasedDate, endDate)}</span>
        </div>
      )}
    </div>
  );
};

export default FlyerHeader;
